














































































































































































































































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch }from 'vue-property-decorator';
import isEqual from 'lodash.isequal';
import isUndefined from 'lodash.isundefined';
import isNull from 'lodash.isnull';
import genericapi  from '../assets/ts/genericAPIAxios';

@Component
export default class EBiennialSearchResult extends Vue {
private store: any = this.$store;
private changeCheckBox: boolean = false;
private isPenaltyApplied: boolean = false;
private disbleFarmCorpCheckBox: boolean = false;
private hasApplicationChanged: boolean = false;
private noChangeRequired: boolean = false;
private applicationSubmitted: boolean = false;
private newObject: any = {};
private clonedNewObject: any = {};
private stateObject: object[] = [];
private countryObject: object[] = [];
private ceoStateObject: object[] = [];
private principleExecOfficeInfoStateObject: object[] = [];
private signerCapacityObject: object[] = [];
private errors = [];
private errorsMessagesFromDB = [];
private validationConfigurationFromDB=[];
private transactionId: any;
private paymentToken: any;
private showFarmCorpExempt: boolean = true;
private emailFormat =
new RegExp(/^[^@\s]+@[^@\s]+\.[^@\s]+$/);
private zipCodeFormat = new RegExp(/(^\d{5}$)|(^\d{5}-\d{4}$)/);
private intFormat = new RegExp(/^(0|[1-9]\d*)$/);
private removeInvalidCharacterFromAddress =
new RegExp(/[.\s]+/g);
private ebiennialIdleTimeOut:any;
private throttletimeOut:any;
private ebiennialNormalFee:any;
private ebiennialNormalFeeMessage:any;
private ebiennialPenaltyFee:any;
private ebiennialPenaltyFeeMessage:any;
//private nameInvalidCharacter = new RegExp(/[*|\":<>[\]{}`\\()';@&$]/);
private nameInvalidCharacter = new RegExp(/[’]/);
private temp = {
  streetAddress: '',
        addressLine2: '',
        city: '',
        state: '',
        zipCode: '',
        country:'',
}

private ceoInfo: any={
      name: '',
      address: {
        ...this.temp
      },
    };
    private prinExecOfficeInfo: any={
      name: '',
      address: {
        ...this.temp
      },
    };
    private serviceOfProcessInfo: any={
      name: '',
      address: {
        ...this.temp
      },
    };
    private filerInfo: any={
      filerContact:{
      name: '',
      address: {
        ...this.temp
      },
      },
    };
    private womenBoardMember: any={
      totalNumberOfBoardMembers:'',
      numberOfWomenBoardMembers:''
    };
    private signerInformation: any={
            signature: false,
            signerName: '',
            signerTitle: '',
    };

  public timeout() {
    setTimeout(() => {
      console.log('Test');
      //this.newObject = JSON.parse(JSON.stringify(this.$store.getters['ebiennial/EBiennialFiling']));
      //console.log(this.newObject);
      if (!isNull(this.$route.params.applicationSubmitted) && !isUndefined(this.$route.params.applicationSubmitted)) {
    console.log('making no change required true and application submitted true');
    this.applicationSubmitted = true;
    this.noChangeRequired = true;
  } else if(this.newObject.farmCorpExemptionFlag == true){
    console.log('making no change required true and application submitted false');
    this.applicationSubmitted = false;
    this.noChangeRequired = true;
  }else {
    console.log('making no change required false and application submitted false');
    this.applicationSubmitted = false;
    this.noChangeRequired = false;
    this.newObject.filerInfo = {
      name: '',
      address: {
        line1: '',
        line2: '',
        city: '',
        state: 'NY',
        zipCode: '',
      },
    };
  };

    }, 500);
}
 private beforeMount(): void {
   console.log('befor mount')
  //this.activateActivityTracker();
};
private userActivityTimeout:any;

private resetUserActivityTimeout() {
  clearTimeout(this.userActivityTimeout);
  this.userActivityTimeout = setTimeout(() => {
    this.inactiveUserAction();
  }, this.ebiennialIdleTimeOut);
}

private inactiveUserAction() {
  // logout logic
  this.$router.push({ name: 'home',params: {sessionTimeOut: 'true'} });
}

private activateActivityTracker() {
  console.log('into activateActivityTracker')
  window.addEventListener("mousemove", this.userActivityThrottler);
  window.addEventListener("scroll", this.userActivityThrottler);
  window.addEventListener("keydown", this.userActivityThrottler);
  window.addEventListener("resize", this.userActivityThrottler);
}
private userActivityThrottlerTimeout = null;

private userActivityThrottler() {
  console.log('into userActivityThrottler')
  if (!this.userActivityThrottlerTimeout) {
    console.log('into set time our for userActivityThrottler')
    this.userActivityThrottlerTimeout = setTimeout(() => {
      this.resetUserActivityTimeout();

      clearTimeout(this.userActivityThrottlerTimeout);
      this.userActivityThrottlerTimeout = null;
    }, this.throttletimeOut);
  }
}
private beforeDestroy() {
  console.log('comig to beforDestroy')
    //window.removeEventListener("mousemove", this.userActivityThrottler);
    //window.removeEventListener("scroll", this.userActivityThrottler);
    //window.removeEventListener("keydown", this.userActivityThrottler);
    //window.removeEventListener("resize", this.userActivityThrottler);
  
    //clearTimeout(this.userActivityTimeout);
    //clearTimeout(this.userActivityThrottlerTimeout);
  }
private created(): void {
//this.timeout();
console.log('Inside created');
console.log('Getting params');
console.log(this.$route.params);
const http = this.$http;
this.newObject = JSON.parse(JSON.stringify(this.$store.getters['ebiennial/EBiennialFiling']));
this.clonedNewObject = JSON.parse(JSON.stringify(this.$store.getters['ebiennial/EBiennialFiling']));
  // this.newObject = JSON.parse(JSON.stringify(this.$store.getters['ebiennial/EBiennialFiling']));
console.log('new object');
console.log(this.newObject);

console.log('cloned new object');
console.log(this.clonedNewObject);
  // this.newObject = JSON.parse(JSON.stringify(this.clonedNewObject));
  // console.log('After cloning');
  // console.log(this.newObject);

if (!isNull(this.$route.params.applicationSubmitted) && !isUndefined(this.$route.params.applicationSubmitted)) {
    console.log('making no change required true and application submitted true');
    this.applicationSubmitted = true;
    this.noChangeRequired = true;
  }else if(this.newObject.farmCorpExemptionFlag == true){
    console.log('making no change required true and application submitted false');
    this.applicationSubmitted = false;
    this.noChangeRequired = true;
  } 
  else {
    console.log('making no change required false and application submitted false');
    this.applicationSubmitted = false;
    this.noChangeRequired = false;
    this.newObject.filerInfo = {
      name: '',
      address: {
        line1: '',
        line2: '',
        city: '',
        state: 'NY',
        zipCode: '',
      },
    };
    this.newObject.signerInformation = {
      signature: false,
      signerName: '',
      signerTitle: '',
    };
  }

console.log('application submitted flag:' + this.applicationSubmitted);

console.log('inside created of verification');
console.log(this.newObject);
console.log('going to get state data');
this.fetchStateBasedOnCountry('USA').then((stateData: any) => {
        this.stateObject = stateData;
        console.log('going to get ceo state data');
        console.log('going to get ceo state data'+this.newObject.ceo.address.country);
        console.log(this.empty(this.newObject.ceo));
        console.log(this.empty(this.newObject.ceo.address));
        console.log(this.empty(this.newObject.ceo.address.country));
        if (!this.empty(this.newObject.ceo) && !this.empty(this.newObject.ceo.address) && !this.empty(this.newObject.ceo.address.country) && this.newObject.ceo.address.country.length>0) {
            this.fetchStateBasedOnCountry(this.newObject.ceo.address.country).then((stateData: any) => {
            this.ceoStateObject = stateData;
          });
        } else if (!this.empty(this.newObject.ceo) && !this.empty(this.newObject.ceo.address) && this.empty(this.newObject.ceo.address.country) ) {
          console.log('Into the else if for ceo');
          this.newObject.ceo.address.country = 'USA';
  //this.fetchStateBasedOnCountry(this.newObject.ceo.address.country).then((stateData: any) => {
        this.ceoStateObject = stateData;
  //  });
          this.newObject.ceo.address.state = 'NY';
        }
        console.log('going to get principal exec office state data');
        console.log('going to get ceo state data'+this.newObject.prinExecOfficeInfo.address.country);
        if (!this.empty(this.newObject.prinExecOfficeInfo) && !this.empty(this.newObject.prinExecOfficeInfo.address) && !this.empty(this.newObject.prinExecOfficeInfo.address.country) && this.newObject.prinExecOfficeInfo.address.country.length>0) {
            this.fetchStateBasedOnCountry(this.newObject.prinExecOfficeInfo.address.country).then((stateData: any) => {
            this.principleExecOfficeInfoStateObject = stateData;
          });
        } else if (!this.empty(this.newObject.prinExecOfficeInfo) && !this.empty(this.newObject.prinExecOfficeInfo.address) && this.empty(this.newObject.prinExecOfficeInfo.address.country)) {
        console.log('Into the else if for prinExecOfficeInfo');
        this.newObject.prinExecOfficeInfo.address.country = 'USA';
        //this.fetchStateBasedOnCountry(this.newObject.prinExecOfficeInfo.address.country).then((stateData: any) => {
        this.principleExecOfficeInfoStateObject = stateData;
        //});
        this.newObject.prinExecOfficeInfo.address.state = 'NY';

        }
        console.log('going to check filerinfo state null');
        if (!isUndefined(this.newObject.filerInfo) && !isNull(this.newObject.filerInfo) && !isUndefined(this.newObject.filerInfo.address) &&
            !isNull(this.newObject.filerInfo.address) && this.empty(this.newObject.filerInfo.address.state)) {
        console.log('inside filerinfo state null');
        this.newObject.filerInfo.address.state = 'NY';
        }
        console.log('going to check serviceOfProcessInfo state null');
        if (!isUndefined(this.newObject.serviceOfProcessInfo) && !isNull(this.newObject.serviceOfProcessInfo) && !isUndefined(this.newObject.serviceOfProcessInfo.address) &&
            !isNull(this.newObject.serviceOfProcessInfo.address) && this.empty(this.newObject.serviceOfProcessInfo.address.state)) {
            console.log('inside serviceOfProcessInfo state null');
            this.newObject.serviceOfProcessInfo.address.state = 'NY';
        }



 });
//console.log('going to get ceo state data');
// if (!this.empty(this.newObject.ceo) && !this.empty(this.newObject.ceo.address) && !this.empty(this.newObject.ceo.address.country)) {
//     this.fetchStateBasedOnCountry(this.newObject.ceo.address.country).then((stateData: any) => {
//         this.ceoStateObject = stateData;
//     });
// } else if (!this.empty(this.newObject.ceo) && !this.empty(this.newObject.ceo.address) && this.empty(this.newObject.ceo.address.country)) {
//   this.newObject.ceo.address.country = 'USA';
//   this.fetchStateBasedOnCountry(this.newObject.ceo.address.country).then((stateData: any) => {
//         this.ceoStateObject = stateData;
//     });
//   this.newObject.ceo.state = 'NY';

// }
//console.log('going to get principal exec office state data');
// if (!this.empty(this.newObject.prinExecOfficeInfo) && !this.empty(this.newObject.prinExecOfficeInfo.address) && !this.empty(this.newObject.prinExecOfficeInfo.address.country)) {
//         this.fetchStateBasedOnCountry(this.newObject.prinExecOfficeInfo.address.country).then((stateData: any) => {
//         this.principleExecOfficeInfoStateObject = stateData;
//     });
//   } else if (!this.empty(this.newObject.prinExecOfficeInfo) && !this.empty(this.newObject.prinExecOfficeInfo.address) && this.empty(this.newObject.prinExecOfficeInfo.address.country)) {
//   this.newObject.prinExecOfficeInfo.address.country = 'US';
//   this.fetchStateBasedOnCountry(this.newObject.prinExecOfficeInfo.address.country).then((stateData: any) => {
//         this.principleExecOfficeInfoStateObject = stateData;
//     });
//   this.newObject.prinExecOfficeInfo.state = 'NY';

// }
console.log('going to get country data');
this.fetchCountry().then((countryData: any) => {
    this.countryObject = JSON.parse(JSON.stringify(countryData));
    if (!isUndefined(this.newObject.ceo) && !isNull(this.newObject.ceo) && !isUndefined(this.newObject.ceo.address) &&
      !isNull(this.newObject.ceo.address) && this.empty(this.newObject.ceo.address.country)) {
      console.log('inside ceo country null');
      this.newObject.ceo.address.country = 'USA';
    }
    console.log('going to check prinExecOfficeInfo country null');
    if (!isUndefined(this.newObject.prinExecOfficeInfo) && !isNull(this.newObject.prinExecOfficeInfo) && !isUndefined(this.newObject.prinExecOfficeInfo.address) &&
      !isNull(this.newObject.prinExecOfficeInfo.address) && this.empty(this.newObject.prinExecOfficeInfo.address.country)) {
      console.log('inside prinExecOfficeInfo country null');
      this.newObject.prinExecOfficeInfo.address.country = 'USA';
    }

    console.log(this.countryObject);
  });
//console.log('going to check filerinfo state null');
// if (!isUndefined(this.newObject.filerInfo) && !isNull(this.newObject.filerInfo) && !isUndefined(this.newObject.filerInfo.address) &&
//       !isNull(this.newObject.filerInfo.address) && this.empty(this.newObject.filerInfo.address.state)) {
//         console.log('inside filerinfo state null');
//         this.newObject.filerInfo.address.state = 'NY';
//   }
//console.log('going to check serviceOfProcessInfo state null');
// if (!isUndefined(this.newObject.serviceOfProcessInfo) && !isNull(this.newObject.serviceOfProcessInfo) && !isUndefined(this.newObject.serviceOfProcessInfo.address) &&
//       !isNull(this.newObject.serviceOfProcessInfo.address) && this.empty(this.newObject.serviceOfProcessInfo.address.state)) {
//         console.log('inside serviceOfProcessInfo state null');
//         this.newObject.serviceOfProcessInfo.address.state = 'NY';
//   }
//console.log('going to check ceo state null');
// if (!isUndefined(this.newObject.ceo) && !isNull(this.newObject.ceo) && !isUndefined(this.newObject.ceo.address) &&
//       !isNull(this.newObject.ceo.address) && this.empty(this.newObject.ceo.address.state)) {
//     console.log('inside ceo state null');
//     this.newObject.ceo.address.state = 'NY';
//   }
//console.log('going to check prinExecOfficeInfo state null');
// if (!isUndefined(this.newObject.prinExecOfficeInfo) && !isNull(this.newObject.prinExecOfficeInfo) && !isUndefined(this.newObject.prinExecOfficeInfo.address) &&
//       !isNull(this.newObject.prinExecOfficeInfo.address) && this.empty(this.newObject.prinExecOfficeInfo.address.state)) {
//     console.log('inside prinExecOfficeInfo state null');
//     this.newObject.prinExecOfficeInfo.address.state = 'NY';
//   }
//console.log('going to check ceo country null');


console.log('Fetching errors from database');
genericapi.get('Generic/GetConfigurationData', {
      params: {
      group: 'ERROR',
      application: 'EBIENNIAL',
    },

    }).then((response: any) => {
      console.log(response);
      this.errorsMessagesFromDB = response.data;
      this.showFarmCorpExempt = (this.getConfigurationValue('SHOW_FARM_EXEMPT_SECTION') === 'true');
      }).catch((error: any) => {
      // this.error = error
      console.log(error);
    });
console.log('Fetching configuration from database');
genericapi.get('Generic/GetConfigurationData', {
      params: {
      group: 'CONFIGURATION',
      application: 'EBIENNIAL',
    },

    }).then((response: any) => {
      console.log(response);
      this.validationConfigurationFromDB = response.data;
      this.ebiennialIdleTimeOut=parseInt(this.getConfigurationValue('EBIENNIAL_IDLE_TIME_OUT'));
      this.throttletimeOut=parseInt(this.getConfigurationValue('EBIENNIAL_THROTTLE_TIME_OUT'));
      this.ebiennialNormalFee=this.getConfigurationValue('EBIENNIAL_NORMAL_FEE_AMOUNT');
      this.ebiennialNormalFeeMessage=this.getConfigurationValue('EBIENNIAL_NORMAL_FEE_MESSSAGE');
      this.ebiennialPenaltyFee=this.getConfigurationValue('EBIENNIAL_PENALTY_AMOUNT');
      this.ebiennialPenaltyFeeMessage=this.getConfigurationValue('EBIENNIAL_PENALTY_FEE_MESSSAGE');
     // this.newObject.feeAmount = '259.00';
      //this.isPenaltyApplied = parseInt(this.newObject.feeAmount)>parseInt(this.ebiennialNormalFee);
      this.isPenaltyApplied = false;
      console.log('isPenaltyApplied:'+this.isPenaltyApplied);
      console.log('this.ebiennialIdleTimeOut:'+this.ebiennialIdleTimeOut);
      console.log('this.throttletimeOut:'+this.throttletimeOut);
      }).catch((error: any) => {
      // this.error = error
      console.log(error);
    });


if (this.newObject.entityTypeInVue === 'CORP') {
        this.signerCapacityObject = [
          {
            text: '', value: '',
          },
          {text: 'OFFICER', value: 'OFFICER'}, {text: 'DIRECTOR', value: 'DIRECTOR'}, {text: 'AUTHORIZED PERSON', value: 'AUTHORIZED PERSON'},
        ];
    } else if (this.newObject.entityTypeInVue === 'LLC') {
        this.signerCapacityObject = [
        {
          text: '', value: '',
        }, {text: 'MEMBER', value: 'MEMBER'}, {text: 'MANAGER', value: 'MANAGER'}, {text: 'AUTHORIZED PERSON', value: 'AUTHORIZED PERSON'},
      ];

    } else if (this.newObject.entityTypeInVue === 'LLP') {
        this.signerCapacityObject = [
          {
            text: '', value: '',
          },
          {text: 'PARTNER', value: 'PARTNER'},
        ];
    }
if (this.newObject.farmCorpExemptionFlag) {
      this.farmCorpChecked();
    }

}

private changeCEOState(countryEvent) {
  this.fetchStateBasedOnCountry(countryEvent.target.value).then((stateData: any) => {
        this.ceoStateObject = stateData;
        this.newObject.ceo.address.country = countryEvent.target.value;
    });
}
private changePrincipalExecOfficeInfoSate(countryEvent) {
  this.fetchStateBasedOnCountry(countryEvent.target.value).then((stateData: any) => {
        this.principleExecOfficeInfoStateObject = stateData;
        this.newObject.prinExecOfficeInfo.address.country = countryEvent.target.value;
    });
}
    private logInformationBeforePayment(loginformation:any) {
      return  this.$http.get('Ebiennial/LogInformationToLogFile', {
          params: {
          loggingInfo: loginformation,
        },

        }).then((response: any) => {
            console.log('after getting response from LogInformationToLogFile');
        }).catch((error: any) => {
            console.log(error);
        });
    }
  private fetchStateBasedOnCountry(countryCodePassed) {

  return genericapi.get('Generic/GetStateData', {
      params: {
      countryCode: countryCodePassed,
    },

    }).then((response: any) => {
      console.log(response);
      return response.data;
      }).catch((error: any) => {
      // this.error = error
      console.log(error);
    });
  }
  private fetchCountry() {
    return genericapi.get('Generic/GetCountryData', {

    }).then((response: any) => {
      console.log(response);
      return  response.data;
      }).catch((error: any) => {
      // this.error = error
      console.log(error);
    });

  }

private populateError(errorCode: string): void {
  console.log('error code passed:' + errorCode);
  for (let i = 0; i < this.errorsMessagesFromDB.length; i++) {
      for (const key in this.errorsMessagesFromDB[i] ) {
        //console.log( key + ' == ' +  this.errorsMessagesFromDB[i][key]);
        if (key === errorCode) {
          // console.log('Matched if');
          this.errors.push(this.errorsMessagesFromDB[i][key]);
        }

      }
  }
}

private getConfigurationValue(keyValue: string): string {
  console.log('keyValue passed:' + keyValue);
  for (let i = 0; i < this.validationConfigurationFromDB.length; i++) {
      for (const key in this.validationConfigurationFromDB[i] ) {
        //console.log( key + ' == ' +  this.errorsMessagesFromDB[i][key]);
        if (key === keyValue) {
          console.log('Matched if:'+this.validationConfigurationFromDB[i][key]);
          return this.validationConfigurationFromDB[i][key];
        }

      }
  }
}

private submitEbiennial(event): void {
  const store = this.$store;
  const http = this.$http;
  console.log(this.newObject);
  const messageDisplay: any = this.$refs.messageDisplay;
  const pageSummaryDiv: any = this.$refs.pageSummary;
  this.errors.length = 0;
  this.validateEbiennialPage();
  this.validateFilerInfo(this.newObject.filerInfo);
  this.validateSignerInfo(this.newObject.signerInformation);
  this.validateEmail(this.newObject.emailForEBiennial)

  if (this.errors.length > 0) {
  this.applicationSubmitted = false;
  if (this.newObject.farmCorpExemptionFlag || this.changeCheckBox) {
    this.noChangeRequired = true;
  } else {
    this.noChangeRequired = false;
  }

  this.disbleFarmCorpCheckBox = false;
  this.$nextTick(() => {
    window.scrollTo(0, messageDisplay.offsetTop);
  });

  } else {
    console.log(this.newObject);
    console.log(this.clonedNewObject);
    if (isEqual(this.newObject.ceo, this.clonedNewObject.ceo) &&
            isEqual(this.newObject.prinExecOfficeInfo, this.clonedNewObject.prinExecOfficeInfo) &&
            isEqual(this.newObject.serviceOfProcessInfo, this.clonedNewObject.serviceOfProcessInfo) &&
            isEqual(this.newObject.womanBoardMember, this.clonedNewObject.womanBoardMember) && !this.changeCheckBox) {
              console.log('Nothing has changed');
              this.populateError('ERR028');
              this.applicationSubmitted = false;
              this.noChangeRequired = false;
              this.disbleFarmCorpCheckBox = false;
              this.$nextTick(() => {
                  window.scrollTo(0, messageDisplay.offsetTop);
                });

            } else {
              console.log('Something has changed');
              this.noChangeRequired = true;
              this.disbleFarmCorpCheckBox = true;
              this.applicationSubmitted = true;
              this.populateSubmitterInfo();
              // this.$nextTick(() => {
              window.scrollTo(0, pageSummaryDiv.offsetTop - 100);
                // });
            }
     // return;
  }

  }
  private populateSubmitterInfo() {

    // Submitter IP, Submitter system id and timestamp will be populated in the middle layer
    this.newObject.submitterInfo.submitterName = this.newObject.signerInformation.signerName;
    this.newObject.submitterInfo.emailAddress = this.newObject.emailForEBiennial;
    this.newObject.SubmitterInfo.postalAddress = {};
    this.newObject.submitterInfo.postalAddress.name = this.newObject.filerInfo.name;
    this.newObject.submitterInfo.postalAddress.streetAddress = this.newObject.filerInfo.address.line1;
    this.newObject.submitterInfo.postalAddress.addressLine2 = this.newObject.filerInfo.address.line1;
    this.newObject.submitterInfo.postalAddress.city = this.newObject.filerInfo.address.line1;
    this.newObject.submitterInfo.postalAddress.state = this.newObject.filerInfo.address.line1;
    this.newObject.submitterInfo.postalAddress.zipCode = this.newObject.filerInfo.address.line1;
    this.newObject.submitterInfo.postalAddress.countryCode = this.newObject.filerInfo.address.line1;
  }
  private validateEbiennialPage() {
  if (this.newObject.entityTypeInVue === 'CORP' && !this.newObject.farmCorpExemptionFlag) {
    if (this.empty(this.newObject.ceo.name)) {
      console.log('CEO name missing');
      this.populateError('ERR001');
    }
    // if (!this.empty(this.newObject.ceo.name) && this.nameInvalidCharacter.test(this.newObject.ceo.name)) {
    //     this.populateError('ERR049');
    //   }

    if (this.empty(this.newObject.ceo.address.line1)) {
      console.log('CEO address line 1 missing');
      this.populateError('ERR002');
    }
    if (this.empty(this.newObject.ceo.address.city)) {
      console.log('CEO address city missing');
      this.populateError('ERR003');
    }
    if(!this.empty(this.newObject.ceo.address.country) && this.newObject.ceo.address.country == 'USA'){
      if (this.empty(this.newObject.ceo.address.zipCode)) {
        console.log('CEO address zipcode or postal code missing');
        this.populateError('ERR005');
      }
    }
    if (this.empty(this.newObject.ceo.address.country)) {
      console.log('CEO address country missing');
      this.populateError('ERR006');
    }
    if(!this.empty(this.newObject.ceo.address.country) && this.newObject.ceo.address.country == 'USA'){
      if(!this.empty(this.newObject.ceo.address.zipCode)){
        if(!this.zipCodeFormat.test(this.newObject.ceo.address.zipCode)){
          this.populateError('ERR039');
        }
      }
    }
    if(!this.empty(this.newObject.ceo.address.country) && this.newObject.ceo.address.country !== 'USA'){
      this.newObject.ceo.address.state = '';
    }    
    // if(!this.empty(this.newObject.ceo.address.country) && this.newObject.ceo.address.country == 'USA'){
    //   if(!this.empty(this.newObject.ceo.address.ZipPlus4)){
    //     if(isNaN(this.newObject.ceo.address.ZipPlus4)){}
    //       this.populateError('ERR040');
    //     }
    //   }
  }
  if (this.newObject.entityTypeInVue === 'CORP'  && !this.newObject.farmCorpExemptionFlag){
    console.log('Board memebr'+this.newObject.womanBoardMember.totalBoardMemberNumber);
    console.log('Women Board memebr'+this.newObject.womanBoardMember.totalWomenBoardMemberNumber);
    if(this.empty(this.newObject.womanBoardMember.totalBoardMemberNumber)){
          this.populateError('ERR035');
    }
    if(this.empty(this.newObject.womanBoardMember.totalWomenBoardMemberNumber) && parseInt(this.newObject.womanBoardMember.totalWomenBoardMemberNumber) != 0){
          this.populateError('ERR036');
    }
    if(!this.empty(this.newObject.womanBoardMember.totalBoardMemberNumber) && parseInt(this.newObject.womanBoardMember.totalBoardMemberNumber) != 0){
          if(isNaN(this.newObject.womanBoardMember.totalBoardMemberNumber) || !this.intFormat.test(this.newObject.womanBoardMember.totalBoardMemberNumber)){
            this.errors.push('Please enter a valid number for the total Number of Directors Constituting the Board of Directors');
          }
          if(this.newObject.womanBoardMember.totalBoardMemberNumber>999){
          //this.populateError('The total number of women board member cannot be more then 999');
            this.errors.push('The total Number of Directors Constituting the Board of Directors cannot be more than 999');
          }
    }else if(!this.empty(this.newObject.womanBoardMember.totalBoardMemberNumber) && !this.intFormat.test(this.newObject.womanBoardMember.totalBoardMemberNumber)){
        this.errors.push('Please enter a valid number for the total Number of Directors Constituting the Board of Directors');
    }
    if(!this.empty(this.newObject.womanBoardMember.totalWomenBoardMemberNumber) && parseInt(this.newObject.womanBoardMember.totalWomenBoardMemberNumber) != 0){
          if(isNaN(this.newObject.womanBoardMember.totalWomenBoardMemberNumber) || !this.intFormat.test(this.newObject.womanBoardMember.totalWomenBoardMemberNumber)){
            this.errors.push('Please enter a valid number for the total number of Directors on the Board of Directors that are Women');
          }

          if(this.newObject.womanBoardMember.totalWomenBoardMemberNumber>999){
            //this.populateError('ERR036');
            this.errors.push('The total number of Directors on the Board of Directors that are Women cannot be more than 999');
          }
    }else if(!this.empty(this.newObject.womanBoardMember.totalWomenBoardMemberNumber) && !this.intFormat.test(this.newObject.womanBoardMember.totalWomenBoardMemberNumber)){
        this.errors.push('Please enter a valid number for the total number of Directors on the Board of Directors that are Women');
    }

    if(!this.empty(this.newObject.womanBoardMember.totalBoardMemberNumber) && 
        this.empty(this.newObject.womanBoardMember.totalWomenBoardMemberNumber) && parseInt(this.newObject.womanBoardMember.totalWomenBoardMemberNumber) != 0){
          this.populateError('ERR033');
    }
    if(this.empty(this.newObject.womanBoardMember.totalBoardMemberNumber) && parseInt(this.newObject.womanBoardMember.totalBoardMemberNumber) != 0 && 
        !this.empty(this.newObject.womanBoardMember.totalWomenBoardMemberNumber)){
          this.populateError('ERR032');
    }
    if(!this.empty(this.newObject.womanBoardMember.totalWomenBoardMemberNumber) && !this.empty(this.newObject.womanBoardMember.totalBoardMemberNumber)){
      if(parseInt(this.newObject.womanBoardMember.totalWomenBoardMemberNumber)>parseInt(this.newObject.womanBoardMember.totalBoardMemberNumber)){
        this.populateError('ERR037');
      }
    }

  }
      if ((this.newObject.entityTypeInVue === 'CORP'  && !this.newObject.farmCorpExemptionFlag) || this.newObject.entityTypeInVue === 'LLP') {
        this.validatePrincipalExecInfo(this.newObject.prinExecOfficeInfo);
  }

      if (!this.newObject.farmCorpExemptionFlag) {
    this.validateServiceOfProcessInfo(this.newObject.serviceOfProcessInfo);
  }
}
  private validatePrincipalExecInfo(principalExecinfo: any): void {
      if (this.empty(principalExecinfo.address.line1)) {
      console.log('Principal executive officer address line 1 missing');
      this.populateError('ERR008');
    }
    var invalidPEOAddressLine12 = this.getConfigurationValue('EBIENNIAL_PEO_VALIDATION_ADDRESS12');
    if (!this.empty(principalExecinfo.address.line1) && this.isDataInvalid(principalExecinfo.address.line1,invalidPEOAddressLine12,true)) {
        this.populateError('ERR056');
    }
    if (!this.empty(principalExecinfo.address.line2) && this.isDataInvalid(principalExecinfo.address.line2,invalidPEOAddressLine12,true)) {
        this.populateError('ERR057');
    }    
      if (this.empty(principalExecinfo.address.city)) {
      console.log('Principal executive officer address city missing');
      this.populateError('ERR009');
    }
    if(!this.empty(principalExecinfo.address.country) && principalExecinfo.address.country == 'USA'){
      if (this.empty(principalExecinfo.address.zipCode)) {
        console.log('Principal executive officer address zipcode or postal code missing');
        this.populateError('ERR011');
      }
    }
    if(!this.empty(principalExecinfo.address.country) && principalExecinfo.address.country == 'USA'){
      if(!this.empty(principalExecinfo.address.zipCode)){
        if(!this.zipCodeFormat.test(principalExecinfo.address.zipCode)){
          this.populateError('ERR041');
        }
      }
    }
    if(!this.empty(principalExecinfo.address.country) && principalExecinfo.address.country !== 'USA'){
      principalExecinfo.address.state = '';
    }    

    // if(!this.empty(principalExecinfo.address.country) && principalExecinfo.address.country == 'USA'){
    //   if(!this.empty(principalExecinfo.address.ZipPlus4)){
    //     if(isNaN(principalExecinfo.address.ZipPlus4)){}
    //       this.populateError('ERR042');
    //     }
    //   }

      if (this.empty(principalExecinfo.address.country)) {
      console.log('Principal executive officer address country missing');
      this.populateError('ERR012');
    }

}
  private validateServiceOfProcessInfo(serviceOfProcessInfo: any): void {
    if (this.empty(serviceOfProcessInfo.name)) {
      console.log('Service of process name missing');
      this.populateError('ERR019');
    }
  var invalidSOPName = this.getConfigurationValue('EBIENNIAL_SOP_VALIDATION_NAME');
  if (!this.empty(serviceOfProcessInfo.name) && this.isDataInvalid(serviceOfProcessInfo.name,invalidSOPName,false)) {
      this.populateError('ERR052');
  }

  if (this.empty(serviceOfProcessInfo.address.line1)) {
      console.log('Service of process address line 1 missing');
      this.populateError('ERR020');
  }
  var invalidSOPAddressLine12 = this.getConfigurationValue('EBIENNIAL_SOP_VALIDATION_ADDRESS12');
  if (!this.empty(serviceOfProcessInfo.address.line1) && this.isDataInvalid(serviceOfProcessInfo.address.line1,invalidSOPAddressLine12,true)) {
      this.populateError('ERR053');
  }
  if (!this.empty(serviceOfProcessInfo.address.line2) && this.isDataInvalid(serviceOfProcessInfo.address.line2,invalidSOPAddressLine12,true)) {
      this.populateError('ERR054');
  }
if (this.empty(serviceOfProcessInfo.address.city)) {
      console.log('Service of process address city missing');
      this.populateError('ERR021');
  }
    if (this.empty(serviceOfProcessInfo.address.state)) {
      console.log('Service of process address state missing');
      this.populateError('ERR022');
    }
    if(!this.empty(serviceOfProcessInfo.address.zipCode)){
      if(!this.zipCodeFormat.test(serviceOfProcessInfo.address.zipCode)){
        this.populateError('ERR043');
      }
    }

    // if(!this.empty(serviceOfProcessInfo.address.country) && serviceOfProcessInfo.address.country == 'USA'){
    //   if(!this.empty(serviceOfProcessInfo.address.ZipPlus4)){
    //     if(isNaN(serviceOfProcessInfo.address.ZipPlus4)){}
    //       this.populateError('ERR044');
    //     }
    //   }
    if (this.empty(serviceOfProcessInfo.address.zipCode)) {
      console.log('Service of process address zipcode or postal code missing');
      this.populateError('ERR023');
    }

}
  private isDataInvalid(name: any, configuratonData: string,shouldUseRegex: boolean):boolean {
    var splitData = configuratonData.split(';');
    console.log('configuratonData:'+configuratonData);
    console.log('number of values splitted to:'+splitData.length)
    if(shouldUseRegex == true){
      var cleanAddress = name.replace(this.removeInvalidCharacterFromAddress,"");
      console.log('address after being cleaned:'+cleanAddress);
      for(var i=0, len=splitData.length; i < len; i++){
        if(cleanAddress.toUpperCase().includes(splitData[i])){
          console.log('matched with this value:'+splitData[i]);
          return true;
        }
      }
    }else{
      var cleanAddress = name;
      console.log('address after being cleaned:'+cleanAddress);
      for(var i=0, len=splitData.length; i < len; i++){
        if(cleanAddress.toUpperCase().includes(splitData[i])){
          console.log('matched with this value:'+splitData[i]);
          return true;
        }
      }

    }
          return false;
  }
private validateFilerInfo(filerInfo: any): void {
      if (this.empty(filerInfo.name)) {
      console.log('Filer name missing');
      this.populateError('ERR013');
    }
      // if (!this.empty(filerInfo.name) && this.nameInvalidCharacter.test(filerInfo.name)) {
      //   this.populateError('ERR051');
      // }

  //if(!this.empty(filerInfo.name)){
      //if(RegExp("^" + filerInfo.name.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&') + "$", "i").test(this.newObject.entityName)){
      //  this.populateError('ERR047');
      //}
    //}
      if (this.empty(filerInfo.address.line1)) {
      console.log('Filer address line 1 missing');
      this.populateError('ERR014');
    }
      if (this.empty(filerInfo.address.city)) {
      console.log('Filer address city missing');
      this.populateError('ERR015');
    }
      if (this.empty(filerInfo.address.state)) {
      console.log('Filer address state missing');
      this.populateError('ERR016');
    }
      if (this.empty(filerInfo.address.zipCode)) {
      console.log('Filer address zipcode or postal code missing');
      this.populateError('ERR017');
    }
    if(!this.empty(filerInfo.address.zipCode)){
      if(!this.zipCodeFormat.test(filerInfo.address.zipCode)){
        this.populateError('ERR045');
      }
    }

    // if(!this.empty(filerInfo.address.country) && filerInfo.address.country == 'USA'){
    //   if(!this.empty(filerInfo.address.ZipPlus4)){
    //     if(isNaN(filerInfo.address.ZipPlus4)){}
    //       this.populateError('ERR046');
    //     }
    //   }

// if (!this.empty(filerInfo.address.zipCode) && !this.zipCodeFormat.test(filerInfo.address.zipCode)) {
    //     this.populateError('ERR039');
    //   }

}
private validateSignerInfo(signerInfo: any): void {
  if (this.empty(signerInfo.signerName)) {
      console.log('Signer name missing');
      this.populateError('ERR025');
    }
      // if (!this.empty(signerInfo.signerName) && this.nameInvalidCharacter.test(signerInfo.signerName)) {
      //   this.populateError('ERR048');
      // }

if (this.empty(signerInfo.signerTitle)) {
      console.log('Signer title missing');
      this.populateError('ERR026');
    }
  if (this.empty(signerInfo.signature)) {
      console.log('Signer check box not checked');
      this.populateError('ERR027');
    }
}
private validateEmail(emailForEbiennial:any):void{

      if(this.empty(emailForEbiennial)){
        console.log('Checking email missng for ebiennial');
        this.populateError('ERR034');
      }
      if (!this.empty(emailForEbiennial) && !this.emailFormat.test(emailForEbiennial.trim())) {
        this.populateError('ERR038');
      }
  

}

  private showPageReadOnly(): boolean {

    console.log('inside call to showPagereadonly');
    console.log('this.noChangeRequired:' + this.noChangeRequired );
    console.log('this.applicationSubmitted:' + this.applicationSubmitted );
    return (this.noChangeRequired || this.applicationSubmitted);

  }
  private saveTransactionData() {
    return this.$http.post('Ebiennial/SaveTransactionData', {
            dosId: this.newObject.dosId,
            entityName: this.newObject.entityName,
            entityType: this.newObject.entityType,
            //ceo: this.newObject.ceo,
            ceoInfo: this.populateCEO(this.newObject.ceo),
            //prinExecOfficeInfo: this.newObject.prinExecOfficeInfo,
            prinExecOfficeInfo: this.populatePrincipalExecinfo(this.newObject.prinExecOfficeInfo),
            //serviceOfProcessInfo: this.newObject.serviceOfProcessInfo,
            serviceOfProcessInfo: this.populateServiceOfProcessInfo(this.newObject.serviceOfProcessInfo),
            //filerInfo: this.newObject.filerInfo,
            filerInfo: this.populateFilerInfo(this.newObject.filerInfo),
            
            farmCorpExemptionFlag: this.newObject.farmCorpExemptionFlag,
            SignatureInfo: this.populateSignerInfo(this.newObject.signerInformation),
            emailForNotification: this.newObject.emailForEBiennial.trim(),
            //paymentInfo: this.newObject.payment,
            feeAmount: this.newObject.feeAmount,
            filingPeriod: this.newObject.filingPeriod,
            womenBoardMember: this.populateBoardInfo(this.newObject.womanBoardMember),
            //SubmitterInfo: this.newObject.submitterInfo,
            }).then((response: any) => {
             console.log(response);
             this.transactionId = response.data;
             return response.data;
    });
  }

 private getPaymenttoken() {
    return this.$http.post('Ebiennial/GetPaymentSharedServiceToken', {
      req:{
            dosId: this.newObject.dosId,
            PaymentAmount: this.newObject.feeAmount,
            merchant_defined_data1:this.transactionId,

      }
            //SubmitterInfo: this.newObject.submitterInfo,
            }).then((response: any) => {
             console.log(response);
             console.log(response.data.token);
             this.paymentToken = response.data.token;
             return response.data;
    });
  }

private populateSignerInfo(passedSignerInfo){
  console.log(passedSignerInfo);
  if(!this.empty(passedSignerInfo.signature)){
    console.log('In the if for total board member not null and not 0');
    this.signerInformation.signature=passedSignerInfo.signature;
  }
  if(!this.empty(passedSignerInfo.signerName)){
    console.log('In the if for women board member not null and not 0');
    this.signerInformation.signerName=passedSignerInfo.signerName.replace(this.nameInvalidCharacter, "'");;
  }
    if(!this.empty(passedSignerInfo.signerTitle)){
    console.log('In the if for women board member not null and not 0');
    this.signerInformation.signerTitle=passedSignerInfo.signerTitle;
  }

  return this.signerInformation;
}
private populateBoardInfo(passedBoardInfo){
  console.log(passedBoardInfo);
  if(!this.empty(passedBoardInfo.totalBoardMemberNumber)){
    console.log('In the if for total board member not null and not 0');
    this.womenBoardMember.totalNumberOfBoardMembers=passedBoardInfo.totalBoardMemberNumber;
  }else if(parseInt(passedBoardInfo.totalBoardMemberNumber) == 0){
    console.log('In the else if for total board member 0');
    this.womenBoardMember.totalNumberOfBoardMembers=passedBoardInfo.totalBoardMemberNumber;
  }
  if(!this.empty(passedBoardInfo.totalWomenBoardMemberNumber)){
    console.log('In the if for women board member not null and not 0');
    this.womenBoardMember.numberOfWomenBoardMembers=passedBoardInfo.totalWomenBoardMemberNumber;
  }else if( parseInt(passedBoardInfo.totalWomenBoardMemberNumber) == 0){
    console.log('In the else if for women board member 0');
    this.womenBoardMember.numberOfWomenBoardMembers=passedBoardInfo.totalWomenBoardMemberNumber;
  }else{
    this.womenBoardMember.numberOfWomenBoardMembers='0';
  }
  return this.womenBoardMember;
}
  private populateServiceOfProcessInfo(pasedServiceOfProcessInfo){
    if(!this.empty(pasedServiceOfProcessInfo.name)){
      this.serviceOfProcessInfo.name=pasedServiceOfProcessInfo.name.replace(this.nameInvalidCharacter, "'");
    }
    if(!this.empty(pasedServiceOfProcessInfo.address) && !this.empty(pasedServiceOfProcessInfo.address.line1)){
      this.serviceOfProcessInfo.address.streetAddress=pasedServiceOfProcessInfo.address.line1;
    }
    if(!this.empty(pasedServiceOfProcessInfo.address) && !this.empty(pasedServiceOfProcessInfo.address.line2)){
      this.serviceOfProcessInfo.address.addressLine2=pasedServiceOfProcessInfo.address.line2;
    }
    if(!this.empty(pasedServiceOfProcessInfo.address) && !this.empty(pasedServiceOfProcessInfo.address.city)){
      this.serviceOfProcessInfo.address.city=pasedServiceOfProcessInfo.address.city;
    }
    if(!this.empty(pasedServiceOfProcessInfo.address) && !this.empty(pasedServiceOfProcessInfo.address.state)){
      this.serviceOfProcessInfo.address.state=pasedServiceOfProcessInfo.address.state
    }
    if(!this.empty(pasedServiceOfProcessInfo.address) && !this.empty(pasedServiceOfProcessInfo.address.zipCode)){
      this.serviceOfProcessInfo.address.zipCode=pasedServiceOfProcessInfo.address.zipCode
    };
    // if(!this.empty(pasedServiceOfProcessInfo.address) && !this.empty(pasedServiceOfProcessInfo.address.ZipPlus4)){
    //   this.serviceOfProcessInfo.address.ZipPlus4=pasedServiceOfProcessInfo.address.ZipPlus4
    // };
    
    return this.serviceOfProcessInfo;
  }
  private populateCEO(ceo){
    if(!this.empty(ceo.name)){
      
      this.ceoInfo.name=ceo.name.replace(this.nameInvalidCharacter, "'");
    }
    if(!this.empty(ceo.address) && !this.empty(ceo.address.line1)){
      this.ceoInfo.address.streetAddress=ceo.address.line1;
    }
    if(!this.empty(ceo.address) && !this.empty(ceo.address.line2)){
      this.ceoInfo.address.addressLine2=ceo.address.line2;
    }
    if(!this.empty(ceo.address) && !this.empty(ceo.address.city)){
      this.ceoInfo.address.city=ceo.address.city;
    }
    if(!this.empty(ceo.address) && !this.empty(ceo.address.state)){
      this.ceoInfo.address.state=ceo.address.state
    }
    if(!this.empty(ceo.address) && !this.empty(ceo.address.zipCode)){
      this.ceoInfo.address.zipCode=ceo.address.zipCode
    };
    // if(!this.empty(ceo.address) && !this.empty(ceo.address.ZipPlus4)){
    //   this.ceoInfo.address.zipCode=ceo.address.ZipPlus4
    // };

  if(!this.empty(ceo.address) && !this.empty(ceo.address.country)){
      this.ceoInfo.address.country=ceo.address.country
    };
    return this.ceoInfo;

  }
  private populatePrincipalExecinfo(passedPrincipalExecInfo){
    if(!this.empty(passedPrincipalExecInfo.name)){
      this.prinExecOfficeInfo.name=passedPrincipalExecInfo.name
    }
    if(!this.empty(passedPrincipalExecInfo.address) && !this.empty(passedPrincipalExecInfo.address.line1)){
      this.prinExecOfficeInfo.address.streetAddress=passedPrincipalExecInfo.address.line1;
    }
    if(!this.empty(passedPrincipalExecInfo.address) && !this.empty(passedPrincipalExecInfo.address.line2)){
       this.prinExecOfficeInfo.address.addressLine2=passedPrincipalExecInfo.address.line2;
    }
    if(!this.empty(passedPrincipalExecInfo.address) && !this.empty(passedPrincipalExecInfo.address.city)){
       this.prinExecOfficeInfo.address.city=passedPrincipalExecInfo.address.city;
    }
    if(!this.empty(passedPrincipalExecInfo.address) && !this.empty(passedPrincipalExecInfo.address.state)){
       this.prinExecOfficeInfo.address.state=passedPrincipalExecInfo.address.state
    }
    if(!this.empty(passedPrincipalExecInfo.address) && !this.empty(passedPrincipalExecInfo.address.zipCode)){
       this.prinExecOfficeInfo.address.zipCode=passedPrincipalExecInfo.address.zipCode
    };
    // if(!this.empty(passedPrincipalExecInfo.address) && !this.empty(passedPrincipalExecInfo.address.ZipPlus4)){
    //    this.prinExecOfficeInfo.address.ZipPlus4=passedPrincipalExecInfo.address.ZipPlus4
    // };

    if(!this.empty(passedPrincipalExecInfo.address) && !this.empty(passedPrincipalExecInfo.address.country)){
       this.prinExecOfficeInfo.address.country=passedPrincipalExecInfo.address.country
    };
    return  this.prinExecOfficeInfo;

  }
  private populateFilerInfo(passedFilerInfo){
    if(!this.empty(passedFilerInfo.name)){
      this.filerInfo.filerContact.name=passedFilerInfo.name.replace(this.nameInvalidCharacter, "'");
    }
    if(!this.empty(passedFilerInfo.address) && !this.empty(passedFilerInfo.address.line1)){
      this.filerInfo.filerContact.address.streetAddress=passedFilerInfo.address.line1;
    }
    if(!this.empty(passedFilerInfo.address) && !this.empty(passedFilerInfo.address.line2)){
      this.filerInfo.filerContact.address.addressLine2=passedFilerInfo.address.line2;
    }
    if(!this.empty(passedFilerInfo.address) && !this.empty(passedFilerInfo.address.city)){
      this.filerInfo.filerContact.address.city=passedFilerInfo.address.city;
    }
    if(!this.empty(passedFilerInfo.address) && !this.empty(passedFilerInfo.address.state)){
      this.filerInfo.filerContact.address.state=passedFilerInfo.address.state
    }
    if(!this.empty(passedFilerInfo.address) && !this.empty(passedFilerInfo.address.zipCode)){
      this.filerInfo.filerContact.address.zipCode=passedFilerInfo.address.zipCode
    };
    // if(!this.empty(passedFilerInfo.address) && !this.empty(passedFilerInfo.address.ZipPlus4)){
    //   this.filerInfo.filerContact.address.ZipPlus4=passedFilerInfo.address.ZipPlus4
    // };

    if(!this.empty(passedFilerInfo.address) && !this.empty(passedFilerInfo.address.country)){
      this.filerInfo.filerContact.address.country=passedFilerInfo.address.country
    };
    return this.filerInfo;

  }
  private redirectToPayment(): void {
    console.log('inside call to redirectToPayment');
    console.log(this.newObject);
    this.$store.commit('ebiennial/setEBiennialData', this.newObject);
    window.sessionStorage.setItem('ebiennialdata', this.newObject);
    window.localStorage.setItem('ebiennialdata', this.newObject);
    this.errors.length = 0;
    let paymentEndPoint;
    let paymentEndPointNew;
    let paymentVersion;
    let totalEndPoint;
    const fee = this.newObject.feeAmount;
    let applicationProfileId;
    let defaultCountry;
    this.saveTransactionData().then((saveTransactionResponse: any) => {
        console.log('transaction response:' + saveTransactionResponse);
        genericapi.get('Generic/GetConfigurationData', {
          params: {
          group: 'PAYMENT',
          application: 'EBIENNIAL',
      },

    }).then((response: any) => {
      console.log(response);

      if (response.status === 200) {
          this.logInformationBeforePayment('Before redirecting to payment and after storing the record in temp table. Merchant defined data1:'+this.transactionId+'DOSID:'+this.newObject.dosId);
          // paymentEndPoint = response.data[response.data.map(function(o) { return o.key; }).indexOf("PAYMENTENDPOINT")].value;
          for (let i = 0; i < response.data.length; i++) {
            for (const key in response.data[i] ) {
              console.log( key + ' == ' +  response.data[i][key]);
              if (key === 'PAYMENTENDPOINT') {
                  paymentEndPoint = response.data[i][key];
                } else if (key === 'APPLICATIONPROFILEID') {
                  applicationProfileId = response.data[i][key];
                }else if(key === 'DEFAULTCOUNTRY'){
                  defaultCountry = response.data[i][key];
                }else if(key === 'APPLICATIONPAYMENTSTARTURL'){
                  paymentEndPointNew=response.data[i][key];
                }else if(key === 'PAYMENT_VERSION'){
                  paymentVersion=response.data[i][key];
                }
              }
          }
          // paymentEndPoint = response.data.PAYMENTENDPOINT;
          paymentEndPoint = paymentEndPoint.trim();
          paymentEndPointNew = paymentEndPointNew.trim();
          console.log('Payment end point:' + paymentEndPoint);
          console.log('Payment new end point:' + paymentEndPointNew);
          // applicationProfileId = response.data[response.data.map(function(o) { return o.key; }).indexOf("APPLICATIONPROFILEID")].value;
          // applicationProfileId = response.data.APPLICATIONPROFILEID;
          console.log('applicationProfileId:' + applicationProfileId);
          if(!this.empty(this.transactionId) && this.transactionId === 'The ebiennial statement has already been file for this entity and dos id'){
              this.errors.push('The Biennial statement has already been file for this entity and dos id');
              this.$nextTick(() => {
              let validationMessageDisplay: any = this.$refs.messageDisplay;
              window.scrollTo(0, validationMessageDisplay.offsetTop);
              //validationMessageDisplay.scrollTop  = validationMessageDisplay.scrollHeight;
              });
          }else if(!this.empty(this.transactionId) && this.transactionId === 'Filing Window Date is not equals to existing Filing Window Date'){
              this.errors.push('The Biennial statement is being filed for the wrong filing period. Please return to the home page and do a search again.');
              this.$nextTick(() => {
              let validationMessageDisplay: any = this.$refs.messageDisplay;
              window.scrollTo(0, validationMessageDisplay.offsetTop);
              });
          }else{
            console.log('payment version:'+paymentVersion);
            if(paymentVersion === '2'){
              this.getPaymenttoken().then((paymentTokenResponse: any) => {
                console.log('payment token response:' + paymentTokenResponse);
                totalEndPoint = paymentEndPointNew +this.paymentToken;
                window.location.href = totalEndPoint;

              }).catch((error: any) => {
              // this.error = error
              this.errors.push(error);
              console.log(error);
              });
            }else{
              totalEndPoint = paymentEndPoint +'&MerchantDefinedData1=' + this.transactionId+'&MerchantDefinedData2=' + this.newObject.dosId+ '&ApplicationProfileId=' + applicationProfileId + '&Amount=' + fee + '&ShowMerchantId=true'+'&Params=ssl_country:'+defaultCountry+',ssl_invoice_number:'+this.transactionId;
              window.location.href = totalEndPoint;
            }
                console.log('totalEndPoint:' + totalEndPoint);



          }
        }
     }).catch((error: any) => {
      // this.error = error
      this.errors.push(error);
      console.log(error);
    });

    }).catch((error: any) => {
      // this.error = error
      this.errors.push(error);
      console.log(error);
    });
    console.log('transactionId:' + this.transactionId);
  }
  private submitApplication() {
    this.newObject.payment = null;

        if(this.newObject.farmCorpExemptionFlag == true){
            this.saveTransactionData().then((saveTransactionResponse: any) => {
            console.log('transaction response:' + saveTransactionResponse);
            this.saveFinalTransaction().then((finalResponse: any) => {
            console.log(finalResponse);
            if (finalResponse.ebiennialFilingResult.requestStatus === 'Success') {
                this.$router.push({ name: 'approved' });
              } else {
                this.$router.push({ name: 'issue' });
              }
            }).catch((error: any) => {
              console.log(error);
              this.$router.push({ name: 'issue' });
            });

        });

        }


  }

  private saveFinalTransaction() {
    return this.$http.post('Ebiennial/EBiennialDataFiling', {
      eBiennialFilingRequest: {
        dosId: this.newObject.dosId,
        entityName: this.newObject.entityName,
        entityType: this.newObject.entityType,
        ceoInfo: this.newObject.ceo,
        prinExecOfficeInfo: this.newObject.prinExecOfficeInfo,
        serviceOfProcessInfo: this.newObject.serviceOfProcessInfo,
        filerInfo: this.populateFilerInfo(this.newObject.filerInfo),
        farmCorpExemptionFlag: this.newObject.farmCorpExemptionFlag,
        signatureInfo: this.newObject.signerInformation,
        emailForNotification: this.newObject.emailForEBiennial,
        paymentInfo: this.newObject.payment,
        feeAmount:this.newObject.feeAmount,
        filingPeriod:this.newObject.filingPeriod,
        womenBoardMember: this.populateBoardInfo(this.newObject.womanBoardMember),
        tempTransactionId:this.transactionId
        
      },
        }).then((response: any) => {
        return response.data;
        console.log('finished saving data');
        console.log(response);
        }).catch((error: any) => {
        console.log(error);
        });
}

    private enableApplication(): void {
      console.log('inside call to enableApplication');
      this.applicationSubmitted = false;
      if (this.changeCheckBox) {
        this.noChangeRequired = true;
      } else {
        this.noChangeRequired = false;
        this.disbleFarmCorpCheckBox = false;
      }
      if (this.newObject.farmCorpExemptionFlag) {
        this.noChangeRequired = true;
      }


  }

private empty(e) {
     console.log('value supplied to empty method:' + e);
     switch (e) {
      case '':
      case "":
      case 0:
      case '0':
      case null:
      case false:
      case typeof this === 'undefined':
      case undefined:
        return true;
      default:
        return false;
    }
  }
  private noChangeRequiredClicked(eventPassed) {
    console.log('no change required clicked value:' + eventPassed.target.checked);
    if (eventPassed.target.checked) {
       console.log('into the first if');
       if (!this.newObject.farmCorpExemptionFlag) {
         this.errors.length = 0;
         // this.changeCheckBox = false;
         this.validateEbiennialPage();
         if (this.errors.length > 0) {
            this.noChangeRequired = false;
            this.disbleFarmCorpCheckBox = false;
            this.$nextTick(() => {
              this.changeCheckBox = false;
            });
            eventPassed.target.checked = false;
            const messageDisplay: any = this.$refs.messageDisplay;
            messageDisplay.scrollTop  = messageDisplay.scrollHeight;
        } else {
          // this.disbleFarmCorpCheckBox = true;
          this.noChangeRequired = true;
        }
       } else {
          this.noChangeRequired = true;
          this.disbleFarmCorpCheckBox = true;
       }

     } else if (!eventPassed.target.checked && this.newObject.farmCorpExemptionFlag) {
       console.log('into the else if');
       this.noChangeRequired = true;
       this.disbleFarmCorpCheckBox = false;
     } else {
       console.log('into the else');
       this.errors.length = 0;
       this.noChangeRequired = false;
       this.disbleFarmCorpCheckBox = false;
     }
  }
  private checkFarmCorpExemption(eventPassed) {
    console.log('Farm corp exemption clicked:' + eventPassed.target.value);
    console.log('Flag value:' + this.newObject.farmCorpExemptionFlag);
    console.log('checked value:' + eventPassed.target.checked);
    console.log('value of farmCorpExemptionFlag:' + this.newObject.farmCorpExemptionFlag);
    if (eventPassed.target.checked) {
        this.errors.length = 0;
        this.farmCorpChecked();
      } else {
        this.noChangeRequired = false;
        this.newObject.ceo = JSON.parse(JSON.stringify(this.clonedNewObject.ceo));
        this.newObject.prinExecOfficeInfo = JSON.parse(JSON.stringify(this.clonedNewObject.prinExecOfficeInfo));
        this.newObject.serviceOfProcessInfo = JSON.parse(JSON.stringify(this.clonedNewObject.serviceOfProcessInfo));
        this.newObject.womanBoardMember = JSON.parse(JSON.stringify(this.clonedNewObject.womanBoardMember));
     }
    this.disbleFarmCorpCheckBox = false;
    this.$nextTick(() => {
       this.newObject.farmCorpExemptionFlag = eventPassed.target.checked;
    });
  }
  private farmCorpChecked() {
       this.newObject.ceo.name = '';
       this.newObject.ceo.address.line1 = '';
       this.newObject.ceo.address.line2 = '';
       this.newObject.ceo.address.city = '';
       this.newObject.ceo.address.state = '';
       this.newObject.ceo.address.zipCode = '';
       this.newObject.ceo.address.ZipPlus4 = '';
       this.newObject.ceo.address.country = '';

       this.newObject.prinExecOfficeInfo.name = '';
       this.newObject.prinExecOfficeInfo.address.line1 = '';
       this.newObject.prinExecOfficeInfo.address.line2 = '';
       this.newObject.prinExecOfficeInfo.address.city = '';
       this.newObject.prinExecOfficeInfo.address.state = '';
       this.newObject.prinExecOfficeInfo.address.zipCode = '';
       this.newObject.prinExecOfficeInfo.address.ZipPlus4 = '';
       this.newObject.prinExecOfficeInfo.address.country = '';

       this.newObject.serviceOfProcessInfo.name = '';
       this.newObject.serviceOfProcessInfo.address.line1 = '';
       this.newObject.serviceOfProcessInfo.address.line2 = '';
       this.newObject.serviceOfProcessInfo.address.city = '';
       this.newObject.serviceOfProcessInfo.address.state = '';
       this.newObject.serviceOfProcessInfo.address.zipCode = '';
       this.newObject.serviceOfProcessInfo.address.ZipPlus4 = '';
       this.newObject.serviceOfProcessInfo.address.country = '';

       this.newObject.womanBoardMember.totalBoardMemberNumber = '';
       this.newObject.womanBoardMember.totalWomenBoardMemberNumber = '';
       this.noChangeRequired = true;
  }

}

